import { render, staticRenderFns } from "./TopSide.vue?vue&type=template&id=b5e53e2e&scoped=true"
import script from "./TopSide.vue?vue&type=script&lang=js"
export * from "./TopSide.vue?vue&type=script&lang=js"
import style0 from "./TopSide.vue?vue&type=style&index=0&id=b5e53e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e53e2e",
  null
  
)

export default component.exports